import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

// The bound existing chart, surfaced as a green chip with a Change affordance so
// staff always know which chart the document will file to and can release it.
// Shared by the redesigned Send-to-Chart and Create-New-Chart modals. Render is
// caller-gated on whether a chart is bound.
const BoundChartChip = ({
  name, dob, mrn, onChange,
}) => {
  const detail = [
    name,
    dob ? `DOB ${dob}` : '',
    mrn ? `MRN ${mrn}` : '',
  ].filter(Boolean).join(' · ');
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '10px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px',
    }}
    >
      <CheckCircleFilled style={{ color: '#52c41a', fontSize: 16 }} />
      <div style={{ flex: 1, fontSize: '13px' }}>
        <strong>Filing to existing chart</strong>
        <div style={{ color: '#3f6600' }}>{detail}</div>
      </div>
      <Button type="link" size="small" style={{ padding: 0 }} onClick={onChange}>
        Change
      </Button>
    </div>
  );
};

BoundChartChip.propTypes = {
  name: PropTypes.string,
  dob: PropTypes.string,
  mrn: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

BoundChartChip.defaultProps = {
  name: '',
  dob: '',
  mrn: '',
};

export default BoundChartChip;
